import { Observable, Subject } from 'rxjs';

/**
 * Ref class used to close the modal. This reference is returned from the
 * modal's service open method.
 */
export class ModalRef {


  private readonly _afterClosed = new Subject<any>();
  afterClosed$: Observable<any> = this._afterClosed.asObservable();

  close() {
    this._afterClosed.next();
  }
}
